import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';

import PrintCategoryOption from './PrintCategoryOption';
import PrintCategoryPrintProductsModal from '../PrintProductsGroup/components/PrintCategoryPrintProducts/modal';
import PrintProductsGroup from '../PrintProductsGroup';
import PrintProductSizeSuccessModal from '../PrintProductsGroup/components/PrintProductSizeSuccessModal';

const propTypes = {
  printCategories: PropTypes.shape({
    records: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }).isRequired,
    ),
  }).isRequired,
  photo: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  onPrintProductItemToggle: PropTypes.func.isRequired,
  onCheckout: PropTypes.func.isRequired,
  renderItem: PropTypes.func,
  readOnly: PropTypes.bool,
  albumMembershipGroup: PropTypes.shape({
    id: PropTypes.string,
  }),
  identity: PropTypes.shape({
    id: PropTypes.string,
  }),
  getCartItem: PropTypes.func,
};

const PrintProductsOption = ({
  printCategories,
  photo,
  onPrintProductItemToggle,
  onCheckout,
  renderItem,
  readOnly,
  albumMembershipGroup,
  identity,
  getCartItem,
  watermarkSettings,
}) => {
  const [configuredAccountCard, setConfiguredAccountCard] = useState(null);
  const [selectedPrintCategory, setSelectedPrintCategory] = useState();

  const handlePrintCategorySelect = printCategory => {
    setSelectedPrintCategory(printCategory);
  };

  return (
    <Fragment>
      {printCategories.records.map(printCategory => {
        if (printCategory.print_products.records.length === 1) {
          return (
            <PrintProductsGroup
              key={printCategory?.id}
              printProducts={printCategory.print_products.records}
              onCartItemToggle={({
                accountCard,
                albumCustomPrint,
                printProductSize,
              }) => {
                onPrintProductItemToggle({
                  accountCard,
                  albumCustomPrint,
                  printProductSize,
                });

                setConfiguredAccountCard(accountCard);
              }}
              readOnly={readOnly}
              photo={photo}
              renderPrintProduct={renderItem}
              albumMembershipGroup={albumMembershipGroup}
              identity={identity}
              getCartItem={getCartItem}
              watermarkSettings={watermarkSettings}
            />
          );
        }

        if (renderItem) {
          return renderItem({
            printCategory,
            onPrintCategorySelect: handlePrintCategorySelect,
          });
        }

        return (
          <PrintCategoryOption
            key={printCategory.id}
            printCategory={printCategory}
            onPrintCategorySelect={handlePrintCategorySelect}
          />
        );
      })}

      {selectedPrintCategory && (
        <PrintCategoryPrintProductsModal
          forceOpen
          photo={photo}
          onClose={() => setSelectedPrintCategory(null)}
          printCategory={selectedPrintCategory}
          onCartItemToggle={({
            accountCard,
            albumCustomPrint,
            printProductSize,
          }) => {
            onPrintProductItemToggle({
              accountCard,
              albumCustomPrint,
              printProductSize,
            });

            setConfiguredAccountCard(accountCard);
            // Cleanup category when adding to cart
            setSelectedPrintCategory(null);
          }}
          readOnly={readOnly}
          getCartItem={getCartItem}
        />
      )}

      {configuredAccountCard && (
        <PrintProductSizeSuccessModal
          forceOpen
          accountCard={configuredAccountCard}
          onCheckout={() => {
            setConfiguredAccountCard(null);
            onCheckout();
          }}
          onDismiss={() => {
            setConfiguredAccountCard(null);
          }}
        />
      )}
    </Fragment>
  );
};

PrintProductsOption.propTypes = propTypes;

export default PrintProductsOption;
